import { Suspense } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { Claims, Status } from "./pages/claims";
import { ClaimsProvider } from "./pages/claims/ClaimsProvider";
import { Home } from "./pages/home";
import {
  Account,
  Billing,
  Coverage,
  Information,
  OnboardingProvider,
  Welcome,
} from "./pages/onboarding";
import { TrackingRenderer } from "./pages/tracking/TrackingRenderer";
import { Loader } from "./shared/Loader";

function App() {
  return (
    <Suspense fallback={<Loader />}>
      <div className="App">
        <div className="Pages">
          <Routes>
            <Route path="/">
              <Route index element={<Home />} />
              <Route path="claims">
                <Route
                  index
                  element={
                    <ClaimsProvider>
                      <Claims />
                    </ClaimsProvider>
                  }
                />
                <Route path=":claimNumber" element={<Status />} />
              </Route>
              <Route path="tracking">
                {/* <Route index element={<div>Tracking Index</div>} /> */}
                <Route path=":shipInsureId" element={<TrackingRenderer />} />
              </Route>
              <Route
                path="onboarding"
                element={
                  <OnboardingProvider>
                    <Outlet />
                  </OnboardingProvider>
                }
              >
                <Route index element={<Welcome />} />
                <Route path="account" element={<Account />} />
                <Route path="information" element={<Information />} />
                <Route path="coverage" element={<Coverage />} />
                <Route path="billing" element={<Billing />} />
              </Route>
            </Route>
          </Routes>
        </div>
      </div>
    </Suspense>
  );
}

export default App;
